var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "search-suggestions" },
    [
      _c("h4", { staticClass: "title" }, [_vm._v("Sugestões")]),
      _vm._v(" "),
      _c("campaign-list", {
        staticClass: "suggestions",
        attrs: {
          search: "",
          "has-favorite": false,
          campaigns: _vm.suggestions,
          "hide-cashback": _vm.hideCashback
        },
        on: { "click-campaign": _vm.$listeners["click-suggestion"] }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c736f90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c736f90","hasScoped":false,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Search/SearchSuggestions.vue
// module id = 2123
// module chunks = 1610